// SEO Configuration based on competitive analysis of top AI/ML and IT staffing companies in USA/Canada 2025

export const seoConfig = {
  home: {
    title: 'IT Staffing & AI/ML Consulting Services Toronto | genTechStaffing',
    description: 'Leading IT staffing agency and AI consulting firm in Toronto. Expert RPA automation, ERP/CRM implementation, generative AI, MLOps, and custom software development. Serving Canada & USA since 2010.',
    keywords: 'IT staffing Toronto, AI consulting Canada, machine learning consulting, IT recruitment Toronto Ontario, AI ML consulting services, tech staffing agency Canada, IT talent acquisition Toronto, enterprise AI consulting'
  },
  
  services: {
    title: 'AI, ML & IT Services | Toronto IT Staffing Agency',
    description: 'Comprehensive IT and AI services including staffing, RPA, ERP/CRM, generative AI implementation, MLOps, and AI governance. Enterprise-grade solutions for businesses across North America.',
    keywords: 'IT services Toronto, AI services Canada, ML consulting, RPA services, ERP implementation, CRM consulting, IT staffing solutions, AI transformation services'
  },
  
  rpa: {
    title: 'Robotic Process Automation (RPA) Services Toronto',
    description: 'Professional RPA implementation and consulting services. Automate repetitive tasks, reduce errors, and achieve 80% processing time reduction. Expert bot development and deployment in Toronto.',
    keywords: 'RPA services Toronto, robotic process automation Canada, RPA implementation, process automation consulting, RPA developers Toronto, automation solutions Ontario, RPA consulting services',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Robotic Process Automation',
      provider: {
        '@type': 'Organization',
        name: 'genTechStaffing'
      },
      areaServed: ['Canada', 'United States'],
      description: 'Enterprise RPA solutions for automating repetitive business processes'
    }
  },
  
  erpCrm: {
    title: 'ERP & CRM Implementation Services | Toronto ERP Consultants',
    description: 'Expert ERP and CRM implementation, integration, and customization services. Microsoft Dynamics, SAP, Salesforce specialists. Transform your business operations with unified systems.',
    keywords: 'ERP implementation Toronto, CRM consulting Canada, ERP consultants Ontario, Microsoft Dynamics implementation, SAP consulting Toronto, Salesforce integration, ERP CRM services Canada',
    schema: {
      '@type': 'Service',
      serviceType: 'ERP/CRM Implementation',
      description: 'Enterprise resource planning and customer relationship management implementation services'
    }
  },
  
  appDevelopment: {
    title: 'Custom Software Development Toronto | Full-Stack Development',
    description: 'Custom application development services including full-stack, mobile apps, and cloud-native solutions. Modern tech stack, agile methodologies, and ongoing support for businesses in Canada.',
    keywords: 'software development Toronto, custom application development Canada, full stack developers Toronto, mobile app development Ontario, cloud native development, web application development Toronto',
    schema: {
      '@type': 'Service',
      serviceType: 'Custom Application Development',
      description: 'Full-stack custom software development for web and mobile platforms'
    }
  },
  
  staffing: {
    title: 'IT Staffing Solutions Toronto | Tech Recruitment Agency Canada',
    description: 'Connect with pre-vetted IT professionals in Toronto and across Canada. Contract, permanent, and project-based IT staffing. Fast placement of developers, engineers, and tech specialists.',
    keywords: 'IT staffing Toronto, tech recruitment agency Canada, IT contractors Toronto, software developer staffing, IT talent acquisition Ontario, technology staffing solutions, IT recruiting Toronto',
    schema: {
      '@type': 'Service',
      serviceType: 'IT Staffing and Recruitment',
      description: 'Professional IT staffing and talent acquisition services'
    }
  },
  
  aiStrategy: {
    title: 'AI Strategy & Readiness Assessment | AI Consulting Toronto',
    description: 'Strategic AI consulting and readiness assessments. Identify AI use-cases, estimate ROI, assess data maturity, and build comprehensive AI roadmaps. Expert AI strategy consultants in Toronto.',
    keywords: 'AI strategy consulting, AI readiness assessment, AI transformation services, AI consulting firms Toronto, AI business strategy, AI implementation roadmap, enterprise AI strategy Canada',
    schema: {
      '@type': 'Service',
      serviceType: 'AI Strategy Consulting',
      description: 'Strategic planning and readiness assessment for AI adoption'
    }
  },
  
  genAiLLM: {
    title: 'Generative AI & LLM Implementation Services | GPT Integration',
    description: 'Expert generative AI and large language model implementation. Custom LLM deployment, fine-tuning, RAG systems, and AI chatbot development. Enterprise-grade LLM solutions in Canada.',
    keywords: 'generative AI services, LLM implementation, GPT integration, AI chatbot development, large language models, LLM consulting, generative AI development Toronto, ChatGPT integration services',
    schema: {
      '@type': 'Service',
      serviceType: 'Generative AI and LLM Implementation',
      description: 'Large language model deployment and generative AI solution development'
    }
  },
  
  dataMlOps: {
    title: 'MLOps & Data Engineering Services | ML Pipeline Development',
    description: 'Professional MLOps consulting and data engineering services. Build production-ready ML pipelines, automate model deployment, and scale AI operations. Expert ML engineers in Toronto.',
    keywords: 'MLOps consulting, data engineering services, ML pipeline development, machine learning operations, ML model deployment, AI infrastructure Toronto, MLOps platform Canada',
    schema: {
      '@type': 'Service',
      serviceType: 'MLOps and Data Engineering',
      description: 'Machine learning operations and production ML pipeline development'
    }
  },
  
  aiGovernance: {
    title: 'AI Governance & Ethics | Responsible AI Consulting Toronto',
    description: 'AI governance frameworks, ethics consulting, and risk management services. Ensure responsible AI deployment with bias mitigation, compliance, and model explainability solutions.',
    keywords: 'AI governance consulting, AI ethics services, responsible AI, AI risk management, AI compliance Toronto, bias mitigation AI, model explainability services, ethical AI consulting',
    schema: {
      '@type': 'Service',
      serviceType: 'AI Governance and Ethics',
      description: 'AI governance frameworks and responsible AI implementation'
    }
  },
  
  industryAi: {
    title: 'Industry-Specific AI Solutions | Domain AI Consulting Toronto',
    description: 'Custom AI solutions for healthcare, finance, manufacturing, retail, and insurance. Domain-expert AI consultants delivering industry-specific implementations across Canada.',
    keywords: 'industry AI solutions, healthcare AI consulting, financial services AI, manufacturing AI, retail AI solutions, AI for insurance, domain specific AI Canada',
    schema: {
      '@type': 'Service',
      serviceType: 'Industry-Specific AI Solutions',
      description: 'Custom AI implementations tailored to specific industry requirements'
    }
  },
  
  aiAutomation: {
    title: 'AI-Powered Workflow Automation | Intelligent Process Automation',
    description: 'AI-powered workflow automation services. Intelligent document processing, customer service automation, and augmented decision support. Achieve 30-50% productivity improvement.',
    keywords: 'AI workflow automation, intelligent process automation, AI powered automation, document processing AI, customer service automation, AI augmentation services Toronto',
    schema: {
      '@type': 'Service',
      serviceType: 'AI-Powered Automation',
      description: 'Intelligent automation solutions leveraging artificial intelligence'
    }
  },
  
  consulting: {
    title: 'IT Consulting Services Toronto | Technology Strategy Consulting',
    description: 'Strategic IT consulting services including digital transformation, cloud migration, and technology roadmap development. Expert IT consultants serving businesses across Ontario.',
    keywords: 'IT consulting Toronto, technology consulting Canada, digital transformation services, cloud migration consulting, IT strategy consulting, technology roadmap development Ontario',
    schema: {
      '@type': 'Service',
      serviceType: 'IT Consulting',
      description: 'Strategic technology consulting and digital transformation services'
    }
  },
  
  about: {
    title: 'About genTechStaffing | Toronto IT Staffing & AI Consulting Experts',
    description: 'Meet our leadership team and learn about genTechStaffing - Toronto\'s trusted IT staffing and AI/ML consulting partner serving Canada and USA since 2010.',
    keywords: 'about genTechStaffing, IT staffing company Toronto, AI consulting firm Canada, technology services provider, IT recruitment experts Ontario'
  },
  
  caseStudies: {
    title: 'Case Studies | Successful AI & IT Projects | genTechStaffing',
    description: 'Real-world success stories: RPA reducing processing time by 80%, healthcare CRM transformation, e-commerce platform development. See our proven track record.',
    keywords: 'AI case studies, IT success stories, RPA implementation results, digital transformation examples, technology project portfolio Toronto'
  },
  
  contact: {
    title: 'Contact Us | Toronto IT Staffing & AI Consulting | (289) 633-4269',
    description: 'Get in touch with genTechStaffing for IT staffing, AI consulting, and technology services. Located in Toronto, Ontario. Call (289) 633-4269 or request a consultation online.',
    keywords: 'contact IT staffing Toronto, AI consulting inquiry, request consultation, Toronto technology services, IT services quote Ontario'
  }
};

// Additional long-tail keywords for blog/content (future use)
export const longTailKeywords = [
  // AI/ML specific
  'best AI consulting companies Canada 2025',
  'top machine learning consulting firms Toronto',
  'AI implementation partners Canada',
  'generative AI consulting services USA',
  'LLM implementation consultants',
  'MLOps service providers Toronto',
  
  // IT Staffing
  'IT staffing agencies Toronto Ontario',
  'tech recruitment firms Canada',
  'contract IT staffing Toronto',
  'permanent IT placement services',
  'software developer recruitment Toronto',
  
  // RPA
  'RPA implementation companies Canada',
  'robotic process automation consultants Toronto',
  'automation services Ontario',
  
  // ERP/CRM
  'ERP implementation consultants Toronto',
  'Microsoft Dynamics consultants Canada',
  'SAP implementation services Ontario',
  'CRM integration specialists Toronto',
  
  // Industry specific
  'AI for healthcare Canada',
  'financial services AI consulting',
  'manufacturing automation solutions',
  'retail AI implementation services'
];

export default seoConfig;